import React, { Fragment, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { operdoneSchema } from '../../../constant-value/schema';
import { OPERDONE_INSERT } from '../../../constant-value';
import { toast } from 'react-toastify';
import api from '../../../services/axiosConfig';
import { SiSpeedtest } from 'react-icons/si';
import { FaRegCalendarAlt } from 'react-icons/fa';
import DatePicker from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import { toEnglishDigits } from '../../../services/functions';
import DateObject from "react-date-object";


const OperReg = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [calendarValue, setCalendarValue] = useState(new Date());
    const [date, setDate] = useState(null);
    const beforeHandler = () => {
        navigate(-1);
    };
    const [operdone, setOperdone] = useState({
        operateId: state.id,
        carId: state.carId,
        operKindId: state.ok_id,
        operDonDate: calendarValue,
        operDonKM: state.programKm4Edit,
        cost: 0,
        description: "",
        opTitle: state.opTitle
    });

    const numberChangeHandler = (evt) => {
        // setFieldValue(evt.target.id, parseFloat(evt.target.value));
        // setSubmitting(false);
        const { id, value } = evt.target;
        
        if (value === '') {
            setFieldValue(id, 0); // هزینه می‌تواند صفر باشد
            setSubmitting(false);
            return;
        }
        
        const numberValue = parseFloat(value);
        
        if (!isNaN(numberValue) && numberValue >= 0) {
            setFieldValue(id, numberValue);
        } else if (numberValue < 0) {
            setFieldValue(id, 0); // اگر منفی بود صفر کن
            toast.warning('مقدار نمی‌تواند منفی باشد');
        } else {
            setFieldValue(id, 0);
        }
        
        setSubmitting(false);
    }

    const stringChangeHandler = (evt) => {
        setFieldValue(evt.target.id, evt.target.value);
        setSubmitting(false);
    }

    const message = (message,type) => {
      if (type==='warn') {
        toast.warning(message, {
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success(message, {
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setSubmitting
    } = useFormik({
        enableReinitialize: true,
        initialValues: operdone,
        validationSchema: operdoneSchema,    
        onSubmit: (values) => {

          // let selectedDate;
          // if (!date) {
          //   selectedDate = new DateObject({ calendar: persian, locale: persian_fa });
          // }  else {
          //   selectedDate = date;
          // }    
          let selectedDate = values.operDonDate;
          if (!selectedDate){
            message('تاریخ انجام را تعیین نمایید!','warn');
            return;
          } 

          // اگر DateObject نیست تبدیلش کن
          if (!(values.operDonDate instanceof DateObject)) {
            selectedDate = new DateObject(values.operDonDate);
          }
          const gregorianDate = toEnglishDigits(
            selectedDate.convert(gregorian, "en").format("YYYY-MM-DD HH:mm:ss")
          );
          const payload = {
            ...values,
            operDonDate: gregorianDate
          };

          api.post(`/${OPERDONE_INSERT}`, payload)
              .then((res) => {
                if (res.data.isSuccess) {
                    // navigate("/all-services");
                    navigate(-1);
                    message(res.data.message,'success');
                } else {
                    message(res.data.message,'warn');   
                }
              });

            // axios.post(`${BASE_URL}/${OPERDONE_INSERT}`, values).then((res) => {
            //     if (res.data.isSuccess) {
            //         navigate("/all-services");
            //         message(res.data.message,'success');
            //     } else {
            //         message(res.data.message,'warn');   
            //     }
            // });
        },
    });

 
  return (
    <Fragment>
      <div className="container mt-3">
        <div className="row">
          {/* ستون سمت چپ - اطلاعات خودرو */}
          <div className="col-md-6 col-12 mb-4 d-flex">
            <div
              className="card shadow-sm rounded-4 p-4 flex-fill"
              style={{ maxHeight: '480px', overflowY: 'auto', fontSize: '1rem' }}
            >
              <div className="mb-4">
                <h6 className="text-secondary mb-1">خودرو</h6>
                <h4 className="mb-3" style={{ fontSize: '1.1rem' }}>{state.car_title}</h4>

                <div className="row mb-3">
                  <div className="col-6">
                    <label className="text-secondary fw-semibold" style={{ fontSize: '1rem' }}>
                      نام سرویس
                    </label>
                    <p className="mb-0" style={{ fontSize: '1rem' }}>{state.opTitle}</p>
                  </div>
                  <div className="col-6">
                    <label className="text-secondary fw-semibold" style={{ fontSize: '1rem' }}>
                      نوع سرویس
                    </label>
                    <p className="mb-0" style={{ fontSize: '1rem' }}>
                      {state.ok_serviceType === 'km' ? 'کارکردی' : 'زمانی'}
                    </p>
                    <div className="text-primary">
                      {state.ok_serviceType === "km" 
                        ? <SiSpeedtest size={22}/> 
                        : <FaRegCalendarAlt size={22}/>}
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div className="mt-4">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label fw-semibold" style={{ fontSize: '1rem' }}>
                      سرویس قبلی در تاریخ
                    </label>
                    <p className="text-muted mb-0" style={{ fontSize: '1rem' }}>{state.lastDateP}</p>
                  </div>
                  <div className="col-6">
                    <label className="form-label fw-semibold" style={{ fontSize: '1rem' }}>
                      سرویس قبلی در کیلومتر
                    </label>
                    <p className="text-muted mb-0" style={{ fontSize: '1rem' }}>{state.lastKm}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ستون سمت راست - فرم */}
          <div className="col-md-6 col-12 mb-4 d-flex">
            <form
              onSubmit={handleSubmit}
              className="border p-3 rounded-3 bg-light flex-fill d-flex flex-column"
              style={{ minHeight: '480px' }}
            >
              <div className="mb-3">
                <div className="form-floating">
                  <input
                    value={values.opTitle}
                    onChange={numberChangeHandler}
                    id="opTitle"
                    type="text"
                    onBlur={handleBlur}
                    className="form-control"
                    readOnly={true}
                  />
                  <label htmlFor="opTitle">عنوان سرویس</label>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="OperDonDate" className="form-label">تاریخ انجام</label>
                <div className="libWrapper">
                    <DatePicker
                      inputClass={`form-control ${errors.operDonDate && touched.operDonDate ? 'is-invalid' : ''}`}
                      calendar={persian}
                      locale={persian_fa}
                      value={values.operDonDate || ""}
                      // onChange={setDate}
                      onChange={(value) => {
                        setFieldValue("operDonDate", value);
                        setSubmitting(false);
                      }}
                      format="YYYY/MM/DD"
                      calendarPosition="bottom-right"
                    />
                </div>
                {errors.operDonDate && touched.operDonDate && (
                  <div className="invalid-feedback d-block">{errors.operDonDate}</div>
                )}
              </div>

              <div className="mb-3">
                <div className="form-floating">
                  <input
                    value={values.operDonKM}
                    onChange={numberChangeHandler}
                    id="operDonKM"
                    type="text"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control ${errors.operDonKM && touched.operDonKM ? "is-invalid" : ""}`}
                  />
                  <label htmlFor="operDonKM">کیلومتر سرویس خودرو</label>
                  {errors.operDonKM && touched.operDonKM && (
                    <div className="invalid-feedback">{errors.operDonKM}</div>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <div className="form-floating">
                  <input
                    value={values.cost}
                    onChange={numberChangeHandler}
                    id="cost"
                    type="text"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control ${errors.cost && touched.cost ? "is-invalid" : ""}`}
                  />
                  <label htmlFor="cost">هزینه سرویس</label>
                  {errors.cost && touched.cost && (
                    <div className="invalid-feedback">{errors.cost}</div>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <div className="form-floating">
                  <input
                    value={values.description}
                    onChange={stringChangeHandler}
                    id="description"
                    type="text"
                    onBlur={handleBlur}
                    className={`form-control ${errors.description && touched.description ? "is-invalid" : ""}`}
                  />
                  <label htmlFor="description">توضیحات</label>
                  {errors.description && touched.description && (
                    <div className="invalid-feedback">{errors.description}</div>
                  )}
                </div>
              </div>

              {/* دکمه‌های اقدام */}
              <div className="d-flex justify-content-between gap-3">
                <button
                  type="button"
                  onClick={beforeHandler}
                  className="btn btn-outline-secondary btn-sm flex-grow-1"
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary btn-sm flex-grow-1"
                >
                  {isSubmitting ? "در حال ذخیره..." : "تایید و ذخیره"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>

  );
};

export default OperReg;